<template>
  <div class="fixed inset-0 overflow-y-auto scrolling-touch z-90">
    <div class="w-full min-h-full flex items-center justify-center p-ogs">
      <div
        class="fixed inset-0 bg-black opacity-70 z-10"
        @click="$emit('close')"
      ></div>
      <div
        :class="{ 'py-6 md:py-15': !snug, 'py-6 md:py-8': snug }"
        class="relative w-full max-w-lg px-6 md:px-12 bg-cream z-20"
      >
        <button
          class="absolute top-0 right-0 flex items-center justify-center h-10 w-10 md:h-15 md:w-15 link"
          @click="$emit('close')"
        >
          <div class="w-4 h-4 md:w-5 md:h-5">
            <IconCross />
          </div>
        </button>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import IconCross from "../../../templates/_includes/svg/icon-cross.svg";

export default {
  name: "Modal",
  components: { IconCross },
  props: {
    snug: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
